import { useState } from "react";
import ModalPrintable from "./modalPrintable/ModalPrintable";
import { Link } from "react-router-dom";
import CpntContentCGVCGU from "./CpntContentCGVCGU";

function CpntFooterFO(): JSX.Element {

  const [showModalPrintable, setShowModalPrintable] = useState(false);
  // const [showModalMentionLegale, setModalMentionLegale] = useState(false);
  const [modalTitle, setmodalTitle] = useState("");
  const [modalContent, setModalContent] = useState<JSX.Element>();
  const [showPrintButton, setshowPrintButton] = useState(true);
  const _date = new Date();


  const handleOpenModalMentionLegale = () => {
    setshowPrintButton(true);
    setShowModalPrintable(true);
    setmodalTitle("Mentions légales");
     setModalContent(
    <>
        <h6>Informations légales :</h6>
        <p>
          En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l’économie numérique, il est précisé ce qui suit : Ce site est édité par la société Electre SA au capital de 148 304 euros, à Directoire et conseil de surveillance dont l’actionnaire majoritaire est le Cercle de la librairie, syndicat interprofessionnel du Livre avec 99,99 % du capital.
        </p>
        <p>
        Le siège social d’Electre SA est au 35, rue Grégoire de Tours, 75279 Paris cedex 06. Son téléphone est le 01 44 41 28 00. Elle est inscrite au Registre du Commerce et des Sociétés (RCS) à Paris sous le numéro B 325 785 210 et le numéro de TVA FR 35 325 785 210.
        Son représentant légal, Directeur général d’Electre SA est Monsieur Michel Lanneau.
        </p>
        <p>
        Les conditions d’hébergement : Le site est hébergé par la société Ecritel, SARL au capital de 2 325 000 €, dont le siège social est au 51 rue le Peletier, 75009 Paris. Le téléphone est le 01 40 61 20 00.
        </p>
        <p>
        Le droit d’accès aux données : La loi n° 78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés s’applique aux informations qui vous concernent. Elle garantit un droit d’accès et de rectification pour vos données personnelles auprès d’Electre. Vous pouvez nous contacter par courrier en précisant vos nom, prénom, adresse et l’objet de votre demande.        
        </p>
    </>
    
    )
  };

  const handleOpenModalCGUCGV = () => {
    setshowPrintButton(true);
    setShowModalPrintable(true);
    setmodalTitle("Conditions générales d'utilisation du site Editeurs Pros et Conditions générales de vente");
    setModalContent(<CpntContentCGVCGU />);
  };
  // const handleOpenModalProtectionDonnees = () => {
  //   setshowPrintButton(true);
  //   setShowModalPrintable(true);
  //   setmodalTitle("Protection des données");
  //    setModalContent(
  //   <>
  //       <h6>Titre :</h6>
  //       <p>
  //        à définir...
  //       </p>
  //   </>
    
  //   )
  // };
  

  return (
    <>
      <footer className="App-footer">
      <div className="container">
        <div className="row">
            <div className="col-12  col-md-3 ">
            <span
                    style={{ color: "#fff", textDecoration: "underline", cursor: "pointer" }}
                    onClick={handleOpenModalMentionLegale}
                  >
                    Mentions légales
                  </span>
            </div>
            <div className="col-12  col-md-3">
              <Link to="/contact" >Aide et contact</Link>
            </div>
            <div className="col-12  col-md-3">
              <Link to="https://accueil.electre.com" target="_blank">Electre</Link>
              </div>
            <div className="col-12  col-md-3">
            <Link to="https://cercledelalibrairie.org" target="_blank">Cercle de la Librairie</Link>
            </div>
        </div>
        <div className="row">
          <div className="col-12  col-md-3 ">
            <span
                style={{ color: "#fff", textDecoration: "underline", cursor: "pointer" }}
                onClick={handleOpenModalCGUCGV}
              >
                CGV / CGU
            </span>
          </div>
          <div className="col-12  col-md-3 offset-md-3">
            <Link to="https://www.lespetitsediteurs.fr" target="_blank">Les petits éditeurs</Link>
          </div>
          <div className="col-12  col-md-3">
              <Link to="https://www.livreshebdo.fr" target="_blank">Livres Hebdo</Link>
                </div>
          </div>
          {/* <div className="row">
            <div className="col-12 col-md-3 ">
            <span
                style={{ color: "#fff", textDecoration: "underline", cursor: "pointer" }}
                onClick={handleOpenModalProtectionDonnees}
              >
                Protection des données
            </span>
          </div>
              </div> */}
        <div className="row Copyright">
          <div className="col-12 ">
  {`Copyright © 2024 ${
                _date?.getFullYear() > 2024 ? "-" + _date?.getFullYear() : ""
              } - Electre`}
          </div>
        </div>
    </div>
        </footer>
      {/* <ToastContainer theme="dark" position="bottom-center" autoClose={2000} /> 
      toastStyle={{ backgroundColor: "#ccc" }} */}
      {showModalPrintable && (
        <ModalPrintable
          handleClose={() => setShowModalPrintable(false)}
          show={showModalPrintable}
          headerText={modalTitle}
          printbutton={showPrintButton}
          modalsize="xl"
        >
            {modalContent !== undefined ? (
                <div>{modalContent}</div>
            ) : (
                <div>Contenu non défini</div>
            )}
        </ModalPrintable>
      )}
      {/* {showModalMentionLegale && (
        <ModalPrintable
          handleClose={() => setModalMentionLegale(false)}
          show={showModalMentionLegale}
          headerText="Mentions légales"
          printbutton={showPrintButton}
          modalsize="xl"
        >
            {modalContent !== undefined ? (
                <div>{modalContent}</div>
            ) : (
                <div>Contenu non défini</div>
            )}
        </ModalPrintable>
      )} */}
    </>
  );
}

export default CpntFooterFO;
